export default function () {
    return [
        {
            path: 'index',
            component: () => import('@/pages/dash/index')
        },
        {
            path: 'tag',
            component: () => import('@/pages/dash/tag/index.vue')
        },
        {
            path: 'devInfo',
            component: () => import('@/pages/devInfo/index.vue')
        },
        {
            path: 'video',
            component: () => import('@/pages/video/index.vue')
        },
        {
            path:'upgrade',
            component: () => import('@/pages/upgrade/index.vue')
        },
        {
            path:'debugTheDevice',
            component: () => import('@/pages/debugTheDevice/index.vue')
        },
        {
            path:'projectMap',
            component: () => import('@/pages/projectMap/index.vue')
        }
    ]
}
